import { styled } from '@robocorp/theme';
import { FC, ReactNode } from 'react';

interface Props {
  variant?: 'default' | 'blue';
  size?: 'medium' | 'large';
  placeholder: ReactNode;
}

const AvatarStyled = styled('span')<Omit<Props, 'placeholder'>>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, variant }) =>
    variant === 'blue' ? theme.colors.blue40.color : theme.colors.grey40.color};
  width: ${({ theme, size }) => (size === 'large' ? theme.sizes.$48 : theme.sizes.$24)};
  height: ${({ theme, size }) => (size === 'large' ? theme.sizes.$48 : theme.sizes.$24)};
  border-radius: ${({ theme, size }) => (size === 'large' ? theme.sizes.$48 : theme.sizes.$24)};
  color: ${({ theme }) => theme.colors.grey0.color};
  outline: 1px solid
    ${({ theme, variant }) =>
      variant === 'blue' ? theme.colors.blue40.color : theme.colors.grey40.color};
  overflow: hidden;
`;

export const AvatarIcon: FC<Props> = ({
  placeholder,
  variant = 'default',
  size = 'medium',
  ...rest
}) => (
  <AvatarStyled variant={variant} size={size} {...rest}>
    <div>{placeholder}</div>
  </AvatarStyled>
);
